export const displayMatchTypeList = [
  { label: "Exact", value: "exact" },
  { label: "Prefix", value: "prefix" },
  { label: "Keyword", value: "keyword" },
  { label: "Domain", value: "domain" },
];
export const RETARGET_BY = {
  WEBSITE_RETARGETING_KNOWN: "websiteRetargetingKnown",
  WEBSITE_RETARGETING_UN_KNOWN: "websiteRetargetingUnKnown",
};
export type RETARGET_BY_TYPE = (typeof RETARGET_BY)[keyof typeof RETARGET_BY];
/*
  "Visitor Insight" is deliberately absent. That option posted to
  `/audiences/display/visitorInsight/{profile,company}` — the legacy SFTP
  pipeline that Pixel Audiences replaces — so creating one here produced an
  audience the vendor knows nothing about. Visitor Insight audiences are now
  created from the Visitor Insights pages; this page is general retargeting only.

  `WEBSITE_RETARGETING_KNOWN` above is KEPT: it is still the stored `retargetBy`
  of every audience created before this, and `Display/infoForm.validation.ts`
  still branches on it. The whole dropdown goes away when the legacy routes are
  deleted — see FOLLOW-UP-AFTER-EXECUTION.md section 1a.
*/
export const RETARGET_BY_VALUES = [
  {
    label: "General Retargeting",
    value: RETARGET_BY.WEBSITE_RETARGETING_UN_KNOWN,
  },
];
